import BaseRoute from "../../../lib/itn-ui-kit/route/base-route";
import { service } from "../../../lib/itn-ui-kit/services/service-container";
import Template from "./template";

export default class ViewDocumentRoute extends BaseRoute {
  @service('repositories/case-repository') caseRepository;
  path = ':id';

  element = <Template />;

  async loader({ params }) {
    const { id } = params;
    const {_case} = this.caseRepository.findRecord(id);
    
    return {_case};
  }
};

